<template>
  <div class="holder" :class="{ labeled: label }">
    <div class="text-sm mb-1 opacity-50 label" v-if="label">
      {{ label }}
    </div>
    <vSelect
      class="select"
      :options="options"
      :label="optionsLabel"
      :value="value"
      :clearable="clearable"
      :multiple="multiple"
      :clearSearchOnSelect="clearSearchOnSelect"
      :reduce="reduce"
      @input="$emit('input', $event)"
      @search="$emit('search', $event)"
    >
      <div slot="no-options"></div>
    </vSelect>
  </div>
</template>

<script>
export default {
  name: 'uiDropdown',
  props: {
    options: Array,
    label: String,
    optionsLabel: String,
    value: [String, Object, Array],
    clearable: Boolean,
    multiple: Boolean,
    clearSearchOnSelect: Boolean,
    reduce: Function
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.select /deep/ .vs__search::placeholder,
.select /deep/ .vs__dropdown-toggle,
.select /deep/ .vs__dropdown-menu {
  background: @grey;
  border: none;
  color: #394066;
  border-radius: 10px;
}

.select /deep/ .vs__dropdown-toggle {
  padding: 8px 10px;
  min-height: 48px;
}

.select /deep/ .vs__selected,
.select /deep/ .vs__search {
  margin: 0;
}

.select.vs--loading /deep/ .vs__selected,
.select.vs--open /deep/ .vs__selected {
  top: 0;
  bottom: 0;
}

.select /deep/ .vs__selected-options {
  align-items: center;
}

.select /deep/ .vs__dropdown-menu {
  background: #fff;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.15);
}

.select /deep/ .vs__clear,
.select /deep/ .vs__open-indicator {
  fill: @dark;
  opacity: 0.3;
  transition: none;
}

.select /deep/ .vs__dropdown-option {
  white-space: normal;
}
</style>
